import './panel.css';

import { Icon } from '@/components/core/Icon';
import { cn } from '@/services/utils';

interface PanelHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    icon?: React.ComponentType<React.ComponentPropsWithoutRef<'svg'>> | string;
    title: string;
    subTitle?: string;
    /** Trailing actions, aligned to the right of the title row. */
    actions?: React.ReactNode;
}

const PanelHeader = ({
    icon,
    title,
    subTitle,
    actions,
    className,
    ...props
}: PanelHeaderProps) => {
    return (
        <div
            className={cn(
                'scoped-panel-header tw-flex tw-flex-col tw-items-start tw-mb-2',
                className
            )}
            {...props}
        >
            <div className={cn(
                'tw-flex tw-flex-row tw-items-center tw-justify-start',
                actions && 'tw-w-full tw-justify-between',
            )}>
                <div className="tw-flex tw-min-w-0 tw-flex-row tw-items-center tw-justify-start">
                    {icon && <Icon icon={icon} size="lg" variant="dark" />}
                    <h1 className="scoped-panel-title tw-ml-2">{title}</h1>
                </div>
                {actions}
            </div>
            {subTitle && (
                <h2 className="scoped-panel-subtitle tw-mt-1 !tw-ml-[35px]">{subTitle}</h2>
            )}
        </div>
    );
};

PanelHeader.displayName = 'PanelHeader';

export { PanelHeader };
